<template>
    <form v-on:submit.prevent="submitForm">
        <div v-if="askIfColleaguesAlreadyRegistered">
            <p class="subheadline">Essen bereits Kollegen mit?</p>
            <div class="control">
                <label for="colleaguesAlreadyRegistered-yes" class="radio">
                    <input type="radio" id="colleaguesAlreadyRegistered-yes" :value="true"
                           v-model="formData.colleaguesAlreadyRegistered" />
                    Ja
                </label>
                <label for="colleaguesAlreadyRegistered-no" class="radio">
                    <input type="radio" id="colleaguesAlreadyRegistered-no" :value="false"
                           v-model="formData.colleaguesAlreadyRegistered" />
                    Nein
                </label>
            </div>
        </div>
        <DeliveryAddress
            v-if="askForDeliveryAddress"
            :salutation-options="deliveryAddressSalutationOptions"
            :include-required-company="true"
            :include-date-of-birth="true"
            :date-of-birth-is-required="false"
            v-model:company="formData.deliveryAddress.company"
            v-model:salutation="formData.deliveryAddress.salutation"
            v-model:first-name="formData.deliveryAddress.firstName"
            v-model:last-name="formData.deliveryAddress.lastName"
            v-model:street="formData.deliveryAddress.street"
            v-model:zip-code="formData.deliveryAddress.zipCode"
            v-model:city="formData.deliveryAddress.city"
            v-model:delivery-info="formData.deliveryAddress.deliveryInfo"
            v-model:phone="formData.deliveryAddress.phone"
            v-model:email="formData.deliveryAddress.email"
            v-model:date-of-birth="formData.deliveryAddress.dateOfBirth"
        />
        <div v-if="askForParticipant">
            <p class="subheadline">Personen-Daten</p>
            <Salutation id="participant-salutation" :salutation-options="deliveryAddressSalutationOptions"
                        v-model:salutation="formData.participant.salutation"/>
            <div>
                <label for="participant-firstName" class="small">Vorname*</label>
                <input id="participant-firstName" class="input" type="text" placeholder="Vorname"
                       v-model="formData.participant.firstName" required />
            </div>
            <div>
                <label for="participant-lastName" class="small">Nachname*</label>
                <input id="participant-lastName" class="input" type="text" placeholder="Nachname"
                       v-model="formData.participant.lastName" required />
            </div>
            <div>
                <label for="participant-phone" class="small">Telefonnummer*</label>
                <input id="participant-phone" class="input" type="text" placeholder="Telefonnummer"
                       v-model="formData.participant.phone" required />
            </div>
            <div>
                <label for="participant-email" class="small">Mailadresse*</label>
                <input id="participant-email" class="input" type="text" placeholder="Mailadresse"
                       v-model="formData.participant.email" required />
            </div>
            <div>
                <label for="participant-dateOfBirth" class="small">Geburtsdatum</label>
                <input id="participant-dateOfBirth" class="input" type="date" :max="today"
                       v-model="formData.participant.dateOfBirth">
            </div>
        </div>
        <BillingAddress
            :salutation-options="billingAddressSalutationOptions"
            :include-optional-company="true"
            v-model:company="formData.billingAddress.company"
            v-model:salutation="formData.billingAddress.salutation"
            v-model:first-name="formData.billingAddress.firstName"
            v-model:last-name="formData.billingAddress.lastName"
            v-model:street="formData.billingAddress.street"
            v-model:zip-code="formData.billingAddress.zipCode"
            v-model:city="formData.billingAddress.city"
            v-model:phone="formData.billingAddress.phone"
            v-model:email="formData.billingAddress.email"
        />
        <Payment
            v-model:payment-method="formData.payment.method"
            v-model:bank-account-owner="formData.payment.bankAccountOwner"
            v-model:bank-name="formData.payment.bankName"
            v-model:bank-bic="formData.payment.bankBic"
            v-model:bank-iban="formData.payment.bankIban"
            v-model:bic-error="bicError"
            v-model:iban-error="ibanError"
            :allowed-payment-methods="allowedPaymentMethods"
        />
        <Password
            v-model:value="formData.password.value"
            v-model:compare="formData.password.compare"
            v-model:error="passwordError"
        />
        <Attention
            v-if="askForAttention"
            v-model:attention-type="formData.attention.type"
            v-model:attention-additional-text="formData.attention.additionalText"
        />
        <div v-if="askIfColleaguesMightBeInterested">
            <p class="subheadline">Denken Sie auch andere Kollegen hätten Interesse an der Belieferung?</p>
            <div class="control">
                <label for="colleaguesInterested-yes" class="radio">
                    <input type="radio" id="colleaguesInterested-yes" :value="true"
                           v-model="formData.colleaguesInterested" />
                    Ja
                </label>
                <label for="colleaguesInterested-no" class="radio">
                    <input type="radio" id="colleaguesInterested-no" :value="false"
                           v-model="formData.colleaguesInterested" />
                    Nein
                </label>
            </div>
        </div>
        <OptionsAndTermsAndCondition
            v-model:billing-via-email="formData.billingViaEmail"
            v-model:subscribe-to-newsletter="formData.subscribeToNewsletter"
            v-model:accepted-terms-and-conditions="formData.acceptedTermsAndConditions"
        />
        <SubmitButton />
    </form>
</template>

<script>
import BillingAddress from '@/views/components/ui/Register/Step1/Form/Part/BillingAddress'
import DeliveryAddress from '@/views/components/ui/Register/Step1/Form/Part/DeliveryAddress'
import Payment from '@/views/components/ui/Register/Step1/Form/Part/Payment'
import Password from '@/views/components/ui/Register/Step1/Form/Part/Password'
import Attention from '@/views/components/ui/Register/Step1/Form/Part/Attention'
import OptionsAndTermsAndCondition from '@/views/components/ui/Register/Step1/Form/Part/OptionsAndTermsAndCondition'
import SubmitButton from '@/views/components/ui/Register/Step1/Form/Part/SubmitButton'
import {allowedPaymentMethods, Destination} from "@/utils/registration";
import Salutation from "@/views/components/ui/Register/Step1/Form/Part/Salutation.vue";
import {format} from "date-fns";

export default {
    name: 'RegisterStep1FormWork',
    components: {
        Salutation,
        BillingAddress,
        DeliveryAddress,
        Payment,
        Password,
        Attention,
        OptionsAndTermsAndCondition,
        SubmitButton
    },
    props: {
        registrationFormOptions: {
            type: Object,
            required: true,
        },
        initialRegistrationData: [Object, null]
    },
    data() {
        return {
            formData: {
                participant: {
                    salutation: this.initialRegistrationData?.participant?.salutation ?? '',
                    firstName: this.initialRegistrationData?.participant?.firstName ?? '',
                    lastName: this.initialRegistrationData?.participant?.lastName ?? '',
                    phone: this.initialRegistrationData?.participant?.phone ?? '',
                    email: this.initialRegistrationData?.participant?.email ?? '',
                    dateOfBirth: this.initialRegistrationData?.participant?.dateOfBirth ?? '',
                },
                deliveryAddress: {
                    company: this.initialRegistrationData?.deliveryAddress?.company ?? '',
                    salutation: this.initialRegistrationData?.deliveryAddress?.salutation ?? '',
                    firstName: this.initialRegistrationData?.deliveryAddress?.firstName ?? '',
                    lastName: this.initialRegistrationData?.deliveryAddress?.lastName ?? '',
                    street: this.initialRegistrationData?.deliveryAddress?.street ?? '',
                    zipCode: this.initialRegistrationData?.deliveryAddress?.zipCode ?? '',
                    city: this.initialRegistrationData?.deliveryAddress?.city ?? '',
                    deliveryInfo: this.initialRegistrationData?.deliveryAddress?.deliveryInfo ?? '',
                    phone: this.initialRegistrationData?.deliveryAddress?.phone ?? '',
                    email: this.initialRegistrationData?.deliveryAddress?.email ?? '',
                    dateOfBirth: this.initialRegistrationData?.deliveryAddress?.dateOfBirth ?? '',
                },
                billingAddress: {
                    company: this.initialRegistrationData?.billingAddress?.company ?? '',
                    salutation: this.initialRegistrationData?.billingAddress?.salutation ?? '',
                    firstName: this.initialRegistrationData?.billingAddress?.firstName ?? '',
                    lastName: this.initialRegistrationData?.billingAddress?.lastName ?? '',
                    street: this.initialRegistrationData?.billingAddress?.street ?? '',
                    zipCode: this.initialRegistrationData?.billingAddress?.zipCode ?? '',
                    city: this.initialRegistrationData?.billingAddress?.city ?? '',
                    phone: this.initialRegistrationData?.billingAddress?.phone ?? '',
                    email: this.initialRegistrationData?.billingAddress?.email ?? '',
                },
                payment: {
                    method: this.initialRegistrationData?.payment?.method ?? '',
                    bankAccountOwner: this.initialRegistrationData?.payment?.bankAccountOwner ?? '',
                    bankName: this.initialRegistrationData?.payment?.bankName ?? '',
                    bankBic: this.initialRegistrationData?.payment?.bankBic ?? '',
                    bankIban: this.initialRegistrationData?.payment?.bankIban ?? ''
                },
                password: {
                    value: this.initialRegistrationData?.password?.value ?? '',
                    compare: this.initialRegistrationData?.password?.compare ?? '',
                },
                attention: {
                    type: this.initialRegistrationData?.attention?.type ?? '',
                    additionalText: this.initialRegistrationData?.attention?.additionalText ?? '',
                },
                billingViaEmail: this.initialRegistrationData?.billingViaEmail ?? false,
                subscribeToNewsletter: this.initialRegistrationData?.subscribeToNewsletter ?? false,
                acceptedTermsAndConditions: this.initialRegistrationData?.acceptedTermsAndConditions ?? false,
                colleaguesAlreadyRegistered: this.initialRegistrationData?.colleaguesAlreadyRegistered ?? false,
                colleaguesInterested: this.initialRegistrationData?.colleaguesInterested ?? false,
            },
            passwordError: '',
            ibanError: '',
            bicError: '',
        }
    },
    computed: {
        askIfColleaguesAlreadyRegistered() {
            return this.registrationFormOptions.institutionName === '';
        },
        askIfColleaguesMightBeInterested() {
            return this.registrationFormOptions.institutionName === ''
                && this.formData.colleaguesAlreadyRegistered === false;
        },
        askForDeliveryAddress() {
            return this.registrationFormOptions.institutionName === '';
        },
        askForParticipant() {
            return this.registrationFormOptions.institutionName !== '';
        },
        askForAttention() {
            return this.registrationFormOptions.institutionName === '';
        },
        allowedPaymentMethods() {
            return allowedPaymentMethods(Destination.Work);
        },
        billingAddressSalutationOptions() {
            if (Array.isArray(this.registrationFormOptions.salutationOptions.billingAddress)) {
                return this.registrationFormOptions.salutationOptions.billingAddress
            }
            return [];
        },
        deliveryAddressSalutationOptions() {
            if (Array.isArray(this.registrationFormOptions.salutationOptions.deliveryAddress)) {
                return this.registrationFormOptions.salutationOptions.deliveryAddress
            }
            return [];
        },
        today() {
            return format(new Date(), 'yyyy-MM-dd')
        },
    },
    methods: {
        submitForm() {
            if (this.passwordError || this.ibanError || this.bicError) {
                return
            }

            this.$emit('submitted', this.formData);
        }
    },
    emits: [
        'submitted'
    ]
}
</script>
